import React, { useState } from "react";
import { Box, Button } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import SwipeableViews from "react-swipeable-views";
import useStyles from "./style.js";
import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@material-ui/icons/ChevronRightRounded";

const Slider = (props) => {
  const classes = useStyles();

  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    if (activeStep == 0) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else {
      setActiveStep(0);
    }
  };
  const handleBack = () => {
    if (activeStep == 1) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else {
      setActiveStep(1);
    }
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Box component="div" className={classes.sliderContent}>
      <Button onClick={handleBack} disableRipple className={classes.btn}>
        <ChevronLeftRoundedIcon className={classes.arrows} />
      </Button>
      <SwipeableViews
        index={activeStep}
        onChangeIndex={handleStepChange}
        className={classes.swiper}
      >
        {props.card1}
        {props.card2}
      </SwipeableViews>
      <Button onClick={handleNext} disableRipple className={classes.btn}>
        <ChevronRightRoundedIcon className={classes.arrows} />
      </Button>
    </Box>
  );
};

export default Slider;
